import { styled } from 'styled-components';

import { spacing } from '#/theme/theme';

export const SearchJobHitHolder = styled.div`
  display: flex;
  flex-direction: column;
  container-type: inline-size;
`;

export const SearchJobHitLabels = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${spacing[8]};
  margin: 15px 0 10px;
`;
